export default function () {
  this.loadCoupon()
}
